/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Form_Fixedeventdate_Label2Inputs */

const en_admin_categories_form_fixedeventdate_label2 = /** @type {(inputs: Admin_Categories_Form_Fixedeventdate_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event date`)
};

const de_admin_categories_form_fixedeventdate_label2 = /** @type {(inputs: Admin_Categories_Form_Fixedeventdate_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsdatum`)
};

/**
* | output |
* | --- |
* | "Event date" |
*
* @param {Admin_Categories_Form_Fixedeventdate_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const admin_categories_form_fixedeventdate_label2 = /** @type {((inputs?: Admin_Categories_Form_Fixedeventdate_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Form_Fixedeventdate_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_categories_form_fixedeventdate_label2(inputs)
	return en_admin_categories_form_fixedeventdate_label2(inputs)
});
export { admin_categories_form_fixedeventdate_label2 as "admin_categories_form_fixedEventDate_label" }